import { QuestionMarkIcon } from "@components/Icons/QuestionMark";
import { FC } from "react";

interface Props {
  label?: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  requiredMessage?: string;
  errors?: any;
  register?: any;
  hidden?: boolean;
  type?: string;
  className?: string;
  pattern?: string;
  autoComplete?: string;
  title?: string;
  maxLength?: number;
  disabled?: true;
  tooltip?: string;
  renderTopRight?: () => JSX.Element;
  prefix?: string;
  min?: string;
  step?: string;
  defaultValue?: string | number;
  metaCopy?: string;
}

export const Input: FC<Props> = ({
  label,
  name,
  required,
  placeholder,
  hidden,
  requiredMessage,
  errors,
  register,
  type = "text",
  className,
  tooltip,
  renderTopRight,
  metaCopy,
  prefix,
  ...props
}) => {
  const errorMessage = errors?.[name]?.message || requiredMessage;

  return (
    <div className={`form-control w-full ${hidden ? "hidden" : ""}`}>
      {label && (
        <div className="flex flex-row justify-between">
          <label className="label" htmlFor={name}>
            <span className="label-text">
              {label} {required ? <span className="text-warning">*</span> : <></>}
            </span>
          </label>
          {metaCopy && <span className="label-text-meta text-2xs text-neutral opacity-50 mt-3">{metaCopy}</span>}
          {tooltip && (
            <div className="tooltip-tight-right tooltip tooltip-top mb-2 -mr-1 flex items-end" data-tip={tooltip}>
              <QuestionMarkIcon className="h-5 h-5 text-neutral opacity-60" strokeWidth={0.2} />
            </div>
          )}
          {renderTopRight && <div className="mb-2 -mr-1 flex items-end">{renderTopRight()}</div>}
        </div>
      )}
      <div className={`${prefix ? "input-group" : ""}`}>
        {prefix && <span className="input-group-text">{prefix}</span>}
        <input
          id={name}
          type={type}
          placeholder={placeholder}
          className={`input-bordered input w-full bg-slate-100 dark:text-slate-500 ${className ?? ""}`}
          {...register(name, { required })}
          {...props}
        />
      </div>
      {errors?.[name] && <span className="pl-1 pt-2 text-xs text-warning">{errorMessage}</span>}
    </div>
  );
};
